// extracted by mini-css-extract-plugin
export default {"row":"XIjlJW","bngRowSlideIn":"jCfFf9","arrowIcon":"d_aJLK"};